import axiosClient from "@/api/common/axiosClient.ts";
import { SupportTicket } from "@/types/supportTicket.ts";

export const getTickets = () => {
  return axiosClient.get<SupportTicket[]>("support-tickets/me/");
};
